<template>
  <div class="OATable">
    <OACard v-if="card">
      <slot name="button"></slot>
      <d2-crud ref="d2Crud" :columns="columns" :data="tableData" :options="options" :selection-row="selectionRow"
        @selection-change="handleSelectionChange" :loading="loading" />
    </OACard>
    <d2-crud v-else ref="d2Crud" :columns="columns" :data="tableData" :options="options" :selection-row="selectionRow"
      @selection-change="handleSelectionChange" :loading="loading" />
  </div>
</template>
<script>
  import d2Crud from "@d2-projects/d2-crud";
  import OACard from "@/components/OACard/OACard";

  export default {
    name: "OATableOnly",
    components: {
      d2Crud,
      OACard
    },
    props: {
      data: {
        default: null
      },
      card: {
        default: true
      },
      columns: {
        default: null
      },
      selectionRow: {
        default: false
      },
      loading: {
        default: false
      },
      size: {
        default: "medium"
      }
    },
    data() {
      return {
        tableData: [],
        options: {
          border: true,
          stripe: true,
          size: this.size
        }
      };
    },
    watch: {
      data: {
        handler: function (val, oldVal) {
          this.tableData = val;
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.handleSearch();
    },
    methods: {
      async handleSearch(val) {
        this.$emit("search");
      },
      handleSelectionChange(selection) {
        this.$emit("selectionChange", selection);
      }
    }
  };

</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/OATable/OATableOnly.vue